import { render, staticRenderFns } from "./TransferOrderToStylist.vue?vue&type=template&id=065b7e3e"
import script from "./TransferOrderToStylist.vue?vue&type=script&lang=js"
export * from "./TransferOrderToStylist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports